export class AudioNotificationsService {
  static playAudio(type: AvailableAudios) {
    try {
      (document.getElementById(type) as any).play().catch((e) => {
        // Ignore
      });
    } catch (e) {
      // Ignore
    }
  }

  static stopAudio(type: AvailableAudios) {
    try {
      (document.getElementById(type) as any).pause().catch((e) => {
        // Ignore
      });
      (document.getElementById(type) as any).currentTime = 0; // rewind to start
    } catch (e) {
      // Ignore
    }
  }
}

export enum AvailableAudios {
  INCOMING_CHAT = "CC_incomming",
  NEW_VISITOR = "CC_visitor",
  QUEUED_VISITOR = "CC_queuee",
  NEW_MESSAGE = "CC_message",
  VIDEO_RECORDING_START = "CC_notification_4",
  INCOMING_CALL = "CC_incoming_call",
  PHONE_RINGING = "CC_phone_ringing",
}
